/* MedBound — cookie banner con consenso REALE (Shopify Customer Privacy API).
   "Alle akzeptieren" concede analytics+marketing+preferences: sblocca i pixel e
   gli eventi (ViewContent, AddToCart, Checkout, Purchase). "Ablehnen" li nega.
   Conforme GDPR: il consenso viene impostato SOLO su click reale dell'utente. */
(function () {
  var KEY = "mb_cookie_v2"; // nuova chiave: ri-mostra il banner a chi aveva già il vecchio

  // Imposta il consenso tramite l'API di Shopify (caricandola se non è pronta).
  function applyConsent(granted, cb) {
    var consent = granted
      ? { analytics: true, marketing: true, preferences: true, sale_of_data: true }
      : { analytics: false, marketing: false, preferences: false, sale_of_data: false };

    function doSet() {
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent(consent, function () { if (cb) cb(); });
          return;
        }
      } catch (e) {}
      if (cb) cb();
    }

    var ready = window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent;
    if (!ready && window.Shopify && Shopify.loadFeatures) {
      try {
        Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () { doSet(); });
        return;
      } catch (e) {}
    }
    doSet();
  }

  try { if (localStorage.getItem(KEY)) return; } catch (e) {}

  function dismiss() {
    try { localStorage.setItem(KEY, "1"); } catch (e) {}
    var b = document.getElementById("mb-cookie");
    if (!b) return;
    b.style.transition = "opacity .25s ease, transform .25s ease";
    b.style.opacity = "0";
    b.style.transform = "translateY(12px)";
    setTimeout(function () { if (b && b.parentNode) b.parentNode.removeChild(b); }, 260);
  }

  function show() {
    if (document.getElementById("mb-cookie")) return;
    var css = '<style>' +
      '#mb-cookie{position:fixed;left:18px;bottom:18px;z-index:2147483000;max-width:380px;width:calc(100% - 36px);' +
        'background:#fff;color:#22303d;border-radius:18px;box-shadow:0 18px 60px rgba(10,25,45,.30);' +
        'padding:20px 22px 18px;font-family:var(--font-body-family,Montserrat,sans-serif);' +
        'animation:mbckIn .35s cubic-bezier(.2,.8,.25,1) both}' +
      '@keyframes mbckIn{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}' +
      '#mb-cookie .mbck-h{display:flex;align-items:center;gap:9px;font-family:var(--font-heading-family,"Tomarik Brush","Passion One",sans-serif);' +
        'font-weight:400;color:#1E4D6F;font-size:21px;line-height:1;margin:0 0 8px}' +
      '#mb-cookie p{margin:0 0 15px;font-size:13.5px;line-height:1.55;color:#52606d}' +
      '#mb-cookie a{color:#1E4D6F;text-decoration:underline;font-weight:600}' +
      '#mb-cookie .mbck-btns{display:flex;gap:10px}' +
      '#mb-cookie button{flex:1;border-radius:99px;padding:12px 14px;font:inherit;font-weight:800;font-size:13.5px;cursor:pointer;transition:filter .15s,background .15s}' +
      '#mb-cookie .mbck-acc{background:#D53A2F;color:#fff;border:0}' +
      '#mb-cookie .mbck-acc:hover{filter:brightness(.94)}' +
      '#mb-cookie .mbck-rej{background:#fff;color:#52606d;border:1.5px solid #d7dde3}' +
      '#mb-cookie .mbck-rej:hover{background:#f3f5f7}' +
      '@media(max-width:560px){#mb-cookie{left:10px;right:10px;bottom:10px;width:auto;max-width:none}}' +
      '</style>';
    var html = '<div id="mb-cookie" role="dialog" aria-label="Cookie-Hinweis">' +
      '<div class="mbck-h"><span aria-hidden="true">🍪</span> Cookies</div>' +
      '<p>Wir verwenden Cookies, damit der Shop und dein Warenkorb funktionieren, und ' +
        '&ndash; mit deiner Einwilligung &ndash; f&uuml;r Analyse und Marketing. ' +
        'Mehr dazu in der <a href="/pages/privacy">Datenschutz&shy;erkl&auml;rung</a>.</p>' +
      '<div class="mbck-btns">' +
        '<button type="button" class="mbck-rej">Ablehnen</button>' +
        '<button type="button" class="mbck-acc">Alle akzeptieren</button>' +
      '</div></div>';
    document.body.insertAdjacentHTML("beforeend", css + html);

    var el = document.getElementById("mb-cookie");
    el.querySelector(".mbck-acc").addEventListener("click", function (e) {
      e.preventDefault();
      applyConsent(true);
      dismiss();
    });
    el.querySelector(".mbck-rej").addEventListener("click", function (e) {
      e.preventDefault();
      applyConsent(false);
      dismiss();
    });
    // Il link "Datenschutz" naviga normalmente (nessun preventDefault).
  }

  if (document.readyState !== "loading") show();
  else document.addEventListener("DOMContentLoaded", show);
})();
